<template>
  <div id="afdc-ev-level-help" v-on-clickaway="closeEvHelp">
    <div id="afdc-ev-level-help-closer" v-on:click="closeEvHelp"><span class="afdc-sr-only">{{ $t('Close') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/></div>

    <div class="afdc-row afdc-clearboth">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("Level 1") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ level1Text }}</p>

        <div class="afdc-ev-connector afdc-center-connector">
          <img src="../assets/images/level-1-2.png">
          <div class="afdc-connector-text">{{ $t("J1772") }}</div>
        </div>
      </div>
    </div>

    <hr class="afdc-ev-level-rule">

    <div class="afdc-row">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("Level 2") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ level2Text }}</p>

        <div class="afdc-ev-connector afdc-center-connector">
          <img src="../assets/images/level-1-2.png">
          <div class="afdc-connector-text">{{ $t("J1772") }}</div>
        </div>
      </div>
    </div>

    <hr class="afdc-ev-level-rule">

    <div class="afdc-row">
      <div class="afdc-col-xl-2">
        <strong>{{ $t("DC Fast") }}</strong>
      </div>
      <div class="afdc-col-xl-10">
        <p>{{ dcFastText }}</p>

        <div class="afdc-ev-connector afdc-float-connector">
          <img src="../assets/images/dc-sae.png">
          <div class="afdc-connector-text">{{ $t("SAE CCS") }}</div>
        </div>

        <div class="afdc-ev-connector afdc-float-connector">
          <img src="../assets/images/dc-chademo.png">
          <div class="afdc-connector-text">{{ $t("CHAdeMO") }}</div>
        </div>

        <div class="afdc-ev-connector afdc-float-connector">
          <img src="../assets/images/dc-tesla.png">
          <div class="afdc-connector-text">{{ $t("Tesla") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'EvLevelHelp',

  mixins: [
    clickaway,
  ],

  computed: {
    level1Text() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 3 to 8 kilometers of range per 1 hour of charging.');
      }
      return this.$t('Level 1 charging is a 120V standard wall plug using a J1772 connector. Provides 2 to 5 miles of range per 1 hour of charging.');
    },

    level2Text() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 16 to 32 kilometers of range per 1 hour of charging.');
      }
      return this.$t('Level 2 charging uses 240V/208V for residential or commercial charging using a J1772 connector. Provides 10 to 20 miles of range per 1 hour of charging.');
    },

    dcFastText() {
      if (this.$store.getters.localeCountry === 'CA') {
        return this.$t('There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 95 to 130 kilometers of range per 20 minutes of charging.');
      }
      return this.$t('There are three types of DC fast charging systems depending on the type of charge port on the vehicle. Provides 60 to 80 miles of range per 20 minutes of charging.');
    },
  },

  methods: {
    closeEvHelp() {
      if (!this.$store.getters.getEvHelpClicked) {
        document.getElementById('afdc-ev-level-help').style.display = 'none';
      }

      this.$store.commit('setEvHelpClicked', false);
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

#ev-level-help {
  display: none;
  position: absolute;
  right: 0;
  z-index: 21;
  height: auto;
  max-height: 625px;
  overflow: auto;
  background-color: #f4f9f5;
  border: 1px solid #999;
  padding: 20px;
  width: 95%;
  max-width: 625px;
  img {
    float: left;
    width: 50px;
    margin: 0 5px 10px 0;
  }
  hr.ev-level-rule {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .connector-text {
    padding-top: 12px;
  }
  .ev-connector {
    width: 150px;
    font-size: 14px;
    &.center-connector {
      margin: 0 auto;
    }
    &.float-connector {
      float: left;
      margin-right: 10px;
    }
  }
  #ev-level-help-closer {
    float: right;
    margin: -10px -5px -10px 5px;
    color: #999;
    font-size: 25px;
    &:hover {
      color: #666;
      cursor: pointer;
    }
  }
}
</style>
